import { render, staticRenderFns } from "./birthdate-selector.component.vue?vue&type=template&id=91a80192&"
import script from "./birthdate-selector.component.vue?vue&type=script&lang=ts&"
export * from "./birthdate-selector.component.vue?vue&type=script&lang=ts&"
import style0 from "./birthdate-selector.component.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "birthdate-selector.component.vue"
export default component.exports